import { authenticatedAxios } from '../backend.service'
const version = 'v2'
const paths = {
  putItemItemDetalleNomina: `${version}/declaraciones/nomina/detalle`,
}

export const updateValuesItemDetalleNomina = async ({ id, idd, dtoItemDetalle }) => {
  if (Object.keys(dtoItemDetalle).includes('cuil')) {
    // dtoItemDetalle.cuil= dtoItemDetalle.cuil.includes('-') ? value.replace(/-/g, '')
    dtoItemDetalle.cuil = String(dtoItemDetalle.cuil).includes('-')
      ? dtoItemDetalle.cuil.replace(/-/g, '')
      : String(dtoItemDetalle.cuil)
  }

  const response = await authenticatedAxios.put(paths.putItemItemDetalleNomina, {
    id: id,
    idDetalleNomina: idd,
    data: dtoItemDetalle,
  })

  if (response.status === 200 || response.status == 400) {
    return response
  }
  return false
}
